import { LitElement, html, CSSResultGroup, nothing } from 'lit'
import { customElement, property, state } from 'lit/decorators.js'
import { SortModes } from 'components/discovery/shared/search/typing/search-results.js'
import { style } from './sort-modes.style.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'
import { t } from '@cloudsuite/mosaic-shared/translations/translator.js'


@customElement('csc-sort-modes')
export class CSCSortModes extends LitElement {
  static override styles: CSSResultGroup = [hostStyle, style]

  @property({ type: Array, attribute: 'sort-options' })
  sortOptions: SortModes[] = []

  @state()
  private selectedOption: SortModes | undefined

  private handleOptionClick(option: SortModes) {
    this.selectedOption = option
    this.dispatchEvent(new CustomEvent('sort-option-selected', {
      detail: option,
      bubbles: true,
      composed: true
    }))
  }

  private findSelectedSortOption(): SortModes | undefined {
    return this.sortOptions.find((opt) => opt.selected) ?? this.sortOptions[0]
  }

  override connectedCallback(): void {
    super.connectedCallback()
    this.selectedOption = this.findSelectedSortOption()
  }

  private renderSortOptionsMobile() {
    return this.sortOptions.length ? html`
      <cse-select
        class="sort-options-mobile"
        value="${this.selectedOption?.id ?? ''}"
        required
      >
        ${this.sortOptions.map((option) => html`
          <cse-option
            value="${option.id}"
            @click=${() => this.handleOptionClick(option)}
          >
            ${option.name}
          </cse-option>
        `)}
      </cse-select>
    ` : nothing
  }

  private renderSortOptionsDesktop() {
    return this.sortOptions.length ? html`
      <cse-dropdown
        class="sort-options-desktop"
        alignment="right"
        description="${t('sort_modes_description', { ns: 'csc-sort-modes', default: 'Sort on: ' })}"
        value="${this.selectedOption?.name ?? ''}"
      >
        ${this.sortOptions.map((option) => html`
          <cse-option
            value="${option.id}"
            @click=${() => this.handleOptionClick(option)}
          >
            ${option.name}
          </cse-option>
        `)}
      </cse-dropdown>
    ` : nothing
  }

  override render() {
    return html`
      ${this.renderSortOptionsDesktop()}
      ${this.renderSortOptionsMobile()}
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'csc-sort-modes': CSCSortModes
  }
}
